import { Events } from '../events/app-events';
import { eventBus } from '../utils/event-bus';
import { ValidatorsFactory } from './validators/validators';
import { Question, createQuestionFromRaw as serverCreateQuestionFromRaw } from '@ahoy/model/dist/question';
export { Question } from '@ahoy/model/dist/question';

export const createQuestionFromRaw = (
  raw: any = undefined,
  overrides: any = {},
  metaData: any = {},
): Question | undefined => {
  if (!raw) return;
  try {
    let serverQuestion = serverCreateQuestionFromRaw(raw, overrides, metaData);
    if (serverQuestion) {
      serverQuestion.validator = ValidatorsFactory.createFromRaw(raw);
      Object.defineProperty(serverQuestion, 'value', {
        get: function() { return this.getInternalValue(); },
      });
      Object.defineProperty(serverQuestion, 'value', {
        set: function(newValue) {
          if (newValue !== this.getInternalValue()) {
            eventBus().emit(
              Events.questionIntermediateChangeEvent(serverQuestion?.questionId as string),
              newValue,
            );
            let isValid = false;
            if (this.validator) {
              isValid = this.validator.validate(newValue);
            } else {
              isValid = true;
            }
            this.setInternalValue(newValue);
            // owner_name is mandatory in zoho so we don't want to emit question update event for it when it's empty
            if ((isValid || (this.isEmpty() && serverQuestion?.questionId != 'owner_name'))) {
              this.setLastValidValue(newValue);
              eventBus().emit(Events.Type.QuestionUpdate, this);
            }
          }
        },
      });
    }
    return serverQuestion;
  } catch {
    return undefined;
  }
};
